import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 3,
    [theme.breakpoints.up("md")]: {
      padding: 40,
    },
    [theme.breakpoints.down("sm")]: {
      padding: 8,
    },
    marginTop: 10,
    [theme.breakpoints.down('sm')]: {
      padding: 12,
    },
  },
  examTitle: {
    textAlign: 'start',
    marginBottom: 20,
    fontSize: 14,
    fontWeight: 'bold',
    backgroundColor: theme.palette.KenColors.neutralBlue50,
    opacity: 0.2,
    color: theme.palette.KenColors.primary,
  },
}));

export default function KenCard(props) {
  const { title } = props;

  const classes = useStyles();

  return (
    <React.Fragment>
      <Paper elevation={0} className={classes.root}>
        {title && (
          <Typography className={classes.examTitle}>{title}</Typography>
        )}

        {props.children}
      </Paper>
    </React.Fragment>
  );
}
